import doButtons from './assets/do_buttons.svg';
import dontButtons from './assets/dont_buttons.svg';
import {
  Text,
  List,
  Table,
  TableRow,
  TableHeader,
  TableBody,
  TableHeaderCell,
  TableCell,
  IconTick,
  IconClear,
  Box,
} from 'braid-design-system';

import * as styles from '#src/components/mdx/mdxComponents.css.ts';

export const BestPracticesTable = () => (
  <Table label="Best practices" alignY="top">
    <TableHeader>
      <TableRow>
        <TableHeaderCell align="center">
          <Text>Do</Text>
        </TableHeaderCell>
        <TableHeaderCell align="center">
          <Text>Don’t</Text>
        </TableHeaderCell>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableCell align="center">
          <Text>
            <Box
              alt="Examples of Apply with SEEK buttons correctly displayed"
              className={styles.img.lightMode}
              component="img"
              src={doButtons}
            />
          </Text>
        </TableCell>
        <TableCell align="center">
          <Text>
            <Box
              alt="Examples of Apply with SEEK buttons missing the logo image, displaying incorrect colours, or failing to cater for long text."
              className={styles.img.lightMode}
              component="img"
              src={dontButtons}
            />
          </Text>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell wrap>
          <List type="icon" icon={<IconTick tone="positive" />} space="medium">
            <Text>
              Position the SEEK arrow logo to the left of the text, either left
              aligned in the button with padding and centred text (preferred),
              or combined with text in the centre.
            </Text>
            <Text>
              Ensure your button is sized to accommodate differing lengths of
              text for translations, such as “Lamar dengan Jobstreet.”
            </Text>
          </List>
        </TableCell>
        <TableCell wrap>
          <List type="icon" icon={<IconClear tone="critical" />} space="medium">
            <Text>
              Do not create or use an Apply with SEEK button with a different
              colour or logo.
            </Text>
            <Text>
              Do not place the SEEK arrow element within the provided text.
            </Text>
            <Text>
              Do not hardcode text for the button. You must always use the
              button text provided by the SEEK API which will return the correct
              brand and translated copy.
            </Text>
          </List>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
